import { Paper, type PaperProps } from '@mui/material';
import type { ReactNode } from 'react';

interface StepPaperProps extends Omit<PaperProps, 'elevation'> {
  children: ReactNode;
}

/**
 * Wraps a wizard step body so that on mobile (xs) the card spans the full
 * viewport edge-to-edge with no border-radius, no shadow, and tighter
 * padding, while keeping the rounded elevated card on larger screens.
 */
export const StepPaper = ({ children, sx, ...rest }: StepPaperProps) => (
  <Paper
    {...rest}
    sx={[
      {
        p: { xs: 2.5, sm: 5, md: 6 },
        borderRadius: { xs: 0, sm: 4 },
        boxShadow: { xs: 'none', sm: (theme) => theme.shadows[1] },
      },
      ...(Array.isArray(sx) ? sx : sx ? [sx] : []),
    ]}
  >
    {children}
  </Paper>
);
